__turbopack_context__.v({
  "criteriaBundle": "criteria-module-scss-module__mY1KoW__criteriaBundle",
  "criteriaContainer": "criteria-module-scss-module__mY1KoW__criteriaContainer",
  "criteriaTitle": "criteria-module-scss-module__mY1KoW__criteriaTitle",
  "criterias": "criteria-module-scss-module__mY1KoW__criterias",
  "tags": "criteria-module-scss-module__mY1KoW__tags",
  "textSizeFix": "criteria-module-scss-module__mY1KoW__textSizeFix",
  "threeLineEllipse": "criteria-module-scss-module__mY1KoW__threeLineEllipse",
});
